import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Gavel } from "lucide-react";
import api from "../lib/api";
import DisputePanel from "../components/DisputePanel";

export default function AdminDisputes() {
  const [orders, setOrders] = useState(null);
  const load = () => api.get("/admin/disputes").then(({ data }) => setOrders(data)).catch(() => setOrders([]));
  useEffect(() => { load(); }, []);
  const open = (orders || []).filter(o => o.confirmation_status === "disputed");
  const closed = (orders || []).filter(o => o.confirmation_status !== "disputed");
  return (
    <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-8" data-testid="admin-disputes-page">
      <div className="text-xs font-mono uppercase tracking-widest text-slate-500 flex items-center gap-1.5"><Gavel className="w-3.5 h-3.5" /> Amministrazione · <Link to="/admin" className="underline" data-testid="link-admin-overview">Riepilogo</Link></div>
      <h1 className="mt-1 font-display text-3xl sm:text-4xl font-extrabold text-slate-900">Contestazioni</h1>
      <p className="mt-1 text-sm text-slate-600">Valuta motivo dell'acquirente e difesa del fornitore, poi decidi: accogliere (annulla/rimborsa il pagamento) o respingere (rilascia il payout).</p>
      {orders === null && <div className="mt-6 text-sm text-slate-500">Caricamento...</div>}
      {orders && open.length === 0 && <div className="mt-6 ga-card p-8 text-center text-sm text-slate-500" data-testid="admin-no-disputes">Nessuna contestazione aperta.</div>}
      <div className="mt-6 space-y-4">
        {open.map(o => <Row key={o.id} o={o} onReload={load} />)}
      </div>
      {closed.length > 0 && (
        <>
          <h2 className="mt-10 font-display text-lg font-bold text-slate-900">Chiuse ({closed.length})</h2>
          <div className="mt-3 space-y-4">{closed.map(o => <Row key={o.id} o={o} onReload={load} />)}</div>
        </>
      )}
    </div>
  );
}

function Row({ o, onReload }) {
  return (
    <div data-testid={`admin-dispute-${o.id}`}>
      <div className="flex items-center justify-between gap-2 mb-2">
        <Link to={`/ordine/${o.id}`} className="font-display text-lg font-bold text-slate-900 hover:underline">{o.title}</Link>
        <div className="text-xs font-mono text-slate-500">{o.restaurant?.name} → {o.winner?.name} · € {Number(o.payment?.amount || 0).toFixed(2)} · {o.payment?.method}</div>
      </div>
      {!o.dispute?.supplier_response && !o.dispute?.resolution && o.dispute?.defense_deadline && new Date(o.dispute.defense_deadline) < Date.now() && (
        <div className="mb-2 text-xs font-semibold text-red-700" data-testid={`admin-defense-expired-${o.id}`}>⚠ Il fornitore non ha risposto entro 48h: puoi decidere sulla base della sola contestazione.</div>
      )}
      <DisputePanel order={o} isWinner={false} isAdmin onReload={onReload} />
    </div>
  );
}
